import React from "react";
import styled from "styled-components";

export default styled.div`
    overflow: ${props => props.overflowAuto ? 'auto' : 'initial'};
`;
